<template>

  <v-app>

    <v-main class="background">

      <v-container class="text-center">

        <!-- ===================== -->
        <!-- Impressum -->
        <!-- ===================== -->

        <section>

          <h1 class="text-h4 mb-8 text-decoration-underline">
            Impressum
          </h1>


          <p class="mb-6">
            <strong class="text-decoration-underline">
              Verantwortlicher:
            </strong><br>
            Ruben Rohletter<br>
            Seeweg 3<br>
            35799 Merenberg
          </p>


          <p class="mb-6">
            <strong class="text-decoration-underline">
              Kontakt:
            </strong><br>

            Telefon:
            <a
              href="tel:+4917631154230"
              class="text-decoration-none"
            >
              +49 176 31154230
            </a>
            <br>

            E-Mail:
            <a
              href="mailto:ruben.rohletter@tr-hygieneprofis.de"
              class="text-decoration-none"
            >
              ruben.rohletter@tr-hygieneprofis.de
            </a>
            <br>

            Website:
            <a
              href="https://www.tr-hygieneprofis.de"
              target="_blank"
              rel="noopener noreferrer"
              class="text-decoration-none"
            >
              www.tr-hygieneprofis.de
            </a>
            <br>

            SteuerID: 460150708
          </p>


          <p class="mb-6">

            <strong class="text-decoration-underline">
              Bei redaktionellen Inhalten:
            </strong><br>

            Verantwortlich nach § 55 Abs.2 RStV<br>

            Digitalbrücke By Marc<br>

            Marc-Alexander Keil<br>

            35578 Wetzlar<br>

            E-Mail:
            <a
              href="mailto:info@digitalbrückebymarc.de"
              class="text-decoration-none"
            >
              info@digitalbrückebymarc.de
            </a>
            <br>

            Webseite:
            <a
              href="https://www.digitalbrückebymarc.de"
              target="_blank"
              rel="noopener noreferrer"
              class="text-decoration-none"
            >
              www.digitalbrückebymarc.de
            </a>

          </p>

        </section>

      </v-container>

    </v-main>

  </v-app>

</template>


<style scoped>

.background {
  background: #ffffff !important;
  min-height: 100vh;

  /* Normale Schrift schwarz */
  color: #000000 !important;
}

/* Alle normalen Texte schwarz */

.background p,
.background h1,
.background strong,
.background section {
  color: #000000 !important;
}


/* Hyperlinks */

.background a {
  color: #72b82a !important;
  text-decoration: none;
}


/* Hyperlinks beim Überfahren */

.background a:hover {
  color: #63a91d !important;
  text-decoration: underline;
}

</style>